<template>
  <v-container fluid class="pa-0">
    <div id="map" class="map"></div>
    <i id="mapSpinner" class="fa fa-spinner fa-spin map-spinner"></i>

    <vue-draggable-resizable
      style="border: none; opacity: 0.8;"
      :resizable="false"
      :x="x"
      :y="y"
      :h="70"
      :w="200"
      :z="1"
      :parent="true"
      :drag-handle="'.drag-handle'"
      class="hidden-xs-only"
    >
      <v-card outline class="mx-auto" style="top: 56px">
        <v-system-bar color="#e60085" class="drag-handle">
          <v-icon color="#ffffff">mdi-information-outline</v-icon>
          <span style="color: #fff">Legenda</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="show = !show">
            <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-btn>
        </v-system-bar>
        <v-card-text class="ma-0 pa-0" style="color: #bd0512">
          <v-expand-transition>
            <div v-show="show">
              <v-container fluid pa-0 pl-1>
                <v-divider></v-divider>Czas zdarzeń:
                <v-row class="ma-0 pa-0">
                  <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                    <v-checkbox
                      class="ma-0 pa-0 chexbox-layer"
                      v-model="currentEvents"
                      label="Aktualne"
                      color="success"
                      :value="currentEvents"
                      @change="changeLayerVisibility"
                      hide-details
                      dense
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                    <v-checkbox
                      class="ma-0 pa-0 chexbox-layer"
                      v-model="futureEvents"
                      label="Przyszłe"
                      color="info"
                      :value="futureEvents"
                      @change="changeLayerVisibility"
                      hide-details
                      dense
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-divider></v-divider>Typy zdarzeń:
                <v-checkbox
                  v-for="item in types"
                  v-model="item.selected"
                  :append-icon="item.ico"
                  :key="item.name"
                  :label="item.name"
                  :value="item.selected"
                  color="black"
                  @input="changeLayerVisibility"
                  @change="changeLayerVisibility"
                  hide-details
                  class="chexbox-layer"
                ></v-checkbox>
                
              </v-container>
            </div>
          </v-expand-transition>
        </v-card-text>
      </v-card>
    </vue-draggable-resizable>

      <v-card
      outline
      class="mx-auto d-sm-none"
      style="position: fixed;bottom: 0;width: 100%; z-index: 1000"
    >
      <v-system-bar color="#e60085">
        <v-icon color="#fff">mdi-information-outline</v-icon>
        <span style="color: #fff">Legenda</span>
        <v-spacer></v-spacer>
        <div>                
          <v-container fluid pa-0>
            <v-row class="ma-0 pa-0">
              <v-col sm="6" md="6" class="ma-0 pa-0">    
                <v-checkbox
                  class="ma-0 pa-0 chexbox-xs-layer"
                  v-model="currentEvents"
                  label="Aktualne"
                  color="#94a60d"
                  :value="currentEvents"
                  @change="changeLayerVisibility"
                  hide-details
                  dense
                ></v-checkbox>
              </v-col>
              <v-col sm="6" md="6" class="ma-0 pa-0">
                <v-checkbox
                  class="ma-0 pa-0 chexbox-xs-layer"
                  v-model="futureEvents"
                  label="Przyszłe"
                  color="#45a3c2"
                  :value="futureEvents"
                  @change="changeLayerVisibility"
                  hide-details
                  dense
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-system-bar>
      <v-card-text class="ma-0 pa-0"  style="border-top: 1px solid #ffffff">
        <div style="display:flex; wdith: 100%; height: 30px">
          <div class="legend-menu-item-left-button">
            <img src="/img/left_light.png" width="8" height="16" />
          </div>
          <div v-for="(item, key) in types"
            :value="item.selected"
            :key="item.name"
            @click="checkLayer(key)"
            :class="(item.selected ? 'legend-menu-item-checked' : 'legend-menu-item')"
          > 
            <v-icon v-bind:style="{ color: '#fff' }">{{ item.ico }}</v-icon>
          </div>
          <div class="legend-menu-item-right-button">
            <img src="/img/right_light.png" width="8" height="16" />
          </div>
        </div>
      </v-card-text>
    </v-card>
    <div id="popupPanel" class="popup-panel d-sm-none"></div>
  </v-container>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import L from "leaflet";
import "../tools/Map";
import "../tools/icons/StatsIcon"
import "leaflet.markercluster";
import "leaflet.locatecontrol";
import VueDraggableResizable from "vue-draggable-resizable";
import StatsPopupVue from "./StatsPopup.vue";
import StatsLimits from "../tools/StatsLimits";
const Qs = require("qs");

export default {
  name: "stats",
  components: { VueDraggableResizable },
  data() {
    return {
      currentEvents: true,
      futureEvents: true,
      currentLocation: null,
      show: true,
      polling: null,
      changeBouncer: null,
      map: null,
      statsData: null,
      tmpGeoLayer: null,
      layerGroups: [],
      layerControl: null,
      types: {
        P: { name: "Pożar", selected: true, layer: {}, icon: "/img/stats/ISP.png", 'ico' : "$fire" }, 
        PD: { name: "Prace drogowe", selected: true, layer: {}, icon: "/img/stats/ISPD.png", 'ico' : "$roadwork" },
        BD: { name: "Blokada drogowa", selected: true, layer: {}, icon: "/img/stats/ISBD.png", 'ico' : "$roadblock" },
        Z: { name: "Zgromadzenie", selected: true, layer: {}, icon: "/img/stats/ISZ.png", 'ico' : "$gathering" },
        IM: { name: "Impreza masowa", selected: true, layer: {}, icon: "/img/stats/ISIM.png", 'ico' : "$stage" },
        UR: { name: "Utrudnienia w ruchu", selected: true, layer: {}, icon: "/img/stats/ISUR.png", 'ico' : "$car" },
        W: { name: "Wypadek", selected: true, layer: {}, icon: "/img/stats/ISW.png", 'ico' : "$accident" }
      }
      
      // PD	Prace drogowe
      // BD	Blokada drogowa
      // Z	Zgromadzenie
      // IM	Impreza masowa
      // UR	Utrudnienia w ruchu
    };
  },
  mounted() {
    this.currentLocation = decodeURI(this.$route.params.scords);
    console.log("coords: ");
    console.log(this.currentLocation);
    this.loadIcons();
    this.initMap();
    this.loadData();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  computed: {
    y() {
      var height = window.innerHeight;
      let destX = height / 2 + 50;
      return destX;
    },
    x() {
      var width = window.innerWidth;
      let destY = width - 210;
      return destY;
    }
  },
  watch: {
    currentEvents() {
      //this.currentEvents = this.$store.state.currentEvents;
    },
    statsData() {
      if (this.layerGroups) {
        for (var eventType in this.layerGroups) {
          var lg = this.layerGroups[eventType];
          //this.map.removeLayer(this.layerGroups[eventType]);
          lg.eachLayer(function(layer) {
            lg.removeLayer(layer);
          });
          //this.layerGroups[eventType].removeLayer();
        }
      }

      this.tmpGeoLayer = L.geoJson(this.statsData, {
        pointToLayer: (feature, latlng) => {
          let that = this;
          let PopupCont = Vue.extend(StatsPopupVue);
          //debugger;
          let popup = new PopupCont({
            propsData: {
              sensordata: feature.properties
            }
          });

          let marker = this.createMarker(null, feature, latlng);

          if (this.layerGroups[feature.properties.event] == null) {
            this.layerGroups[feature.properties.event] = L.layerGroup();
          }
          this.layerGroups[feature.properties.event].addLayer(marker);

        
          marker.on("click", function(e) {
            Map.showPopup(that.map, that.$vuetify.breakpoint.name, popup, e, function() {
              return that.getMarkerColor(feature);
            });
          });

          return marker;
        },
        onEachFeature: (feature, layer) => {
          let that = this;
          let PopupCont = Vue.extend(StatsPopupVue);

          let popup = new PopupCont({
            propsData: {
              sensordata: feature.properties
            }
          });

          let marker = this.createMarker(layer, feature);

          if (this.layerGroups[feature.properties.event] == null) {
            this.layerGroups[feature.properties.event] = L.layerGroup();
          }
          this.layerGroups[feature.properties.event].addLayer(layer);
          this.layerGroups[feature.properties.event].addLayer(marker);
          
          marker.on("click", function(e) {
            Map.showPopup(that.map, that.$vuetify.breakpoint.name, popup, e, function() {
              return that.getMarkerColor(feature);
            });
          });
        }
      });


      for (var layerGroup in this.layerGroups) {
        this.map.addLayer(this.layerGroups[layerGroup]);
        this.types[layerGroup].layer = this.layerGroups[layerGroup];
      }
    }
  },
  methods: {
    checkLayer(key) {

      this.types[key].selected = !this.types[key].selected;
      this.loadData();
    },
    getMarkerColor(feature) {
      let dateobj = new Date();
      let todayISO = dateobj.toISOString();
      let color = StatsLimits.getColor('past');

      let startime = feature.properties.startdatetime;

      if (startime > todayISO) {
        color = StatsLimits.getColor('future');
      }

      return color;
    },
    createMarker(layer, feature, latlng) {
      let icon = "";
      let center = null;
      let eventTypeDescription = '';
      let color =  this.getMarkerColor(feature);

      //set merker icon and description
      if (this.types[feature.properties.event] !== null && this.types[feature.properties.event] !== undefined) {
        icon = this.types[feature.properties.event].icon;
        eventTypeDescription = this.types[feature.properties.event].name;
      } else {
        console.log(" event type not found: " + feature.properties.event);
      }

      //set marker position
      if (latlng !== null && latlng !== undefined) {
        center = latlng;
      } else {
        if (feature.geometry.type === 'Polygon' || feature.geometry.type === 'LineString') {
          let bounds = layer.getBounds();
          center = bounds.getCenter();
        } else {
          center = feature.geometry.coordinates;
        }
      }

      //create and return marker
      return L.marker(center, {
        icon: L.statsIcon({
          color: color,
          icon: icon
        })
      });
    },
    changeLayerVisibility(val) {
      //  console.log(val);
      //  console.log(this.types);
      this.$store.commit("SET_CURRENT", this.currentEvents);
      this.$store.commit("SET_FUTURE", this.futureEvents);
      this.loadData();
    },
    loadIcons() {
    },
    pollData() {
      this.polling = setInterval(() => {
        this.loadData();
      }, 60000);
    },
    loadData() {
      let spinner = document.getElementById("mapSpinner");
      spinner.style.display = "block";

      var constraintsGEO = Map.getConstraints(this.map);
      let constraints = [];
      
      var dateobj = new Date();
      var todayISO = dateobj.toISOString();
      if (this.currentEvents && this.futureEvents)
        constraints.push("enddatetime+gte+" + todayISO);
      if (this.currentEvents && !this.futureEvents) {
        constraints.push("startdatetime+lte+" + todayISO);
        constraints.push("enddatetime+gte+" + todayISO);
      }
      if (!this.currentEvents && this.futureEvents) {
        constraints.push("startdatetime+gte+" + todayISO);
        constraints.push("enddatetime+gte+" + todayISO);
      }
      if (!this.currentEvents && !this.futureEvents) {
        constraints.push("startdatetime+gt+" + todayISO);
        constraints.push("enddatetime+lt+" + todayISO);
      }
      constraints.push("note+eq+Tak");
      for (var key in this.types) {
        if (!this.types[key].selected) {
          constraints.push("event+neq+" + key);
        }
      }
      axios
        .get("/IOCNext/api/spatial/static_information", {
          params: {
            boundaries: constraintsGEO,
            criterion: constraints,
            sort: ["startdatetime+desc", "enddatetime+desc"]
          },
          paramsSerializer: function(params) {
            return Qs.stringify(params, { arrayFormat: "repeat" });
          }
        })
        .then(response => {
          this.statsData = response.data;
          let spinner = document.getElementById("mapSpinner");
          spinner.style.display = "none";
          //console.log(this.statsData);
        })
        .catch(error => console.log(error));
    },
    getCenter(arr) {
      var xtotal = 0.0;
      var ytotal = 0.0;
      for ( var i = 0; i < arr.length; i++) {
          if(i%2 == 0)
            ytotal += Number(arr[i]);
          else
            xtotal += Number(arr[i]);    
      }
        return [ (ytotal * 2)/arr.length, (xtotal * 2)/arr.length];        
    },
    initMap() {
      this.map = Map.initMap(50.259894, 19.016368, 13);

       if(this.currentLocation){
         console.log("locationParams: "+this.currentLocation)
         var tmp = this.currentLocation.split(",");
          var tmp2 = this.getCenter(tmp);
         var x = tmp2[1];
         var y = tmp2[0];
         if(x&&y){
            console.log("FLY TO: "+x+","+y);
            this.map.flyTo([x, y], 17);
            }
        }

      Map.addTile(this.map);
      Map.addZoomControl(this.map);

      axios
        .get("/KatowiceSmall.geojson", {})
        .then(response => {
          console.log("borders receivied");
          var citiBoundaries = new L.geoJSON(response.data, {
            style: { fillOpacity: 0.08 }
          }).addTo(this.map);
        })
        .catch(error => console.log(error));

      this.map.on("moveend", () => {
        if (this.changeBouncer) clearTimeout(this.changeBouncer);
        this.changeBouncer = setTimeout(this.loadData, 1150);
      });
    }
  }
};
</script>

<style>
.legend-menu-item {
  padding-top: 4px;
  padding-bottom:4px;
  display:inline-block;
  width: 100%;
  text-align:center;
  color:white;
  background-color:#e60085;
  border-left: 1px solid #ffffff;
  cursor: pointer;
}

.legend-menu-item-left-button {
  padding-top: 6px;
  display:inline-block;
  width: 100%;
  text-align:center;
  color:white;
  background-color:#e60085;
  cursor: pointer
}

.legend-menu-item-right-button {
  padding-top: 6px;
  display:inline-block;
  width: 100%;
  text-align:center;
  color:white;
  background-color:#e60085;
  cursor: pointer;
  border-left: 1px solid #ffffff;
}

.legend-menu-item-checked {
  padding-top: 4px;
  padding-bottom:4px;
  display:inline-block;
  width: 100%;
  text-align:center;
  color:white;
  background-color:#be006e;
  border-left: 1px solid #ffffff;
  cursor: pointer;
}

.marker {
  display: block;
  width: 38px;
  height: 38px;
  padding: 2px;
  border: 0px solid black;
  border-radius: 15px;
}

.marker-icon-cl {
  background: transparent;
  border: 0px solid transparent;
  border-radius: 15px;
  text-align: center;
  line-height: 25px;
}
.marker-icon {
  background: transparent;
  border: 0px solid transparent;
  border-radius: 15px;
  text-align: center;
  line-height: 35px;
}
#map {
  height: 100vh;
  width: 100%;
  z-index: 1;
}

.leaflet-control-zoom-in {
  background-color: #e60085 !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 0px !important;
}

.leaflet-control-zoom-out {
  background-color: #e60085 !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 0px !important;
  margin-top: 5px;
}

.leaflet-bar-part-single {
  background-color: #e60085 !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 0px !important;
}

.leaflet-control-zoom {
  border: none !important;
  border-radius: 0px !important;
  margin-top: 5em !important;
}

.leaflet-control-layers-toggle {
  background-color: #e60085 !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 0px !important;
}

.leaflet-control {
  border: none !important;
  border-radius: 0px !important;
}

.leaflet-control-layers {
  background-color: #e60085 !important;
  color: #ffffff !important;
  margin-top: 5em !important;
}

.leaflet-control-layers-list {
  background-color: #e60085 !important;
  color: #ffffff !important;
}

.mdi-chevron-down::before {
  background: url("/img/down_light.png") no-repeat center center;
  width: 16px;
  height: 8px;
  content: "";
}

.mdi-chevron-up::before {
  background: url("/img/up_light.png") no-repeat center center;
  width: 16px;
  height: 8px;
  content: "";
}

.popup-panel {
  position: fixed;
  bottom: 54px;
  width: 100%;
  height: auto;
  background-color: #fff;
  z-index: 9999;
  display: none;
  overflow: hidden;
}

.popup-panel-pointer {
  position: fixed;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 20px solid transparent;
  left: 50%;
  margin-left: -16px;
  margin-top: -20px;
  z-index: 9999;
}

.chexbox-layer {
  padding: 0px !important;
  margin: 0px !important;
  margin-bottom: 2px !important;
}

.chexbox-layer > .v-input__control {
  width: 100%;
}

.chexbox-layer > .v-input__append-outer {
  padding-right: 5px;
}

.chexbox-layer > .v-input__control > .v-input__slot > .v-label {
  color: #bd0512 !important;
  font-size: 0.8em !important;
}

.chexbox-xs-layer {
  padding: 0px !important;
  margin: 0px !important;
}

.chexbox-xs-layer > .v-input__control > .v-input__slot > .v-label {
  color: #ffffff !important;
  font-size: 0.8em !important;
}

.chexbox-xs-layer > .v-input__control > .v-input__slot > .v-input--selection-controls__input {
  padding: 0px !important;
  margin: 0px !important;
}

.map-spinner {
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -40px;
  font-size: 80px;
  color: #e60085;
  z-index: 600;
  display: none;
  opacity: 0.5;
}
</style>
